export default {
  classTribIBSCBSCollection: [],
  CSTIBSCBSCollection: [],
  classTribISCollection: [],
  CSTISCollection: [],
  codCredPresCollection: [],
};
